export const MEDIA_DYNAMIC_GUIDELINE_PREFIX = 'media_';
export const INNER_GRID_GUIDELINE_PREFIX = 'grid_';
